
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSingleLogo, updateLogoEntry } from '../../Store/PHPSlice/Logo';
import { useParams } from 'react-router-dom';



const LogoEdit = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        logoId: parseInt(Id),
        logoNm: '',
        logoImg: 'noImage',
        userId: userdata?.ID
    });

    const dispatch = useDispatch();
    const singleLogo = useSelector((state) => state.LogoData.singleLogo || { data: [] });
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    useEffect(() => {
        dispatch(fetchSingleLogo(Id));
    }, [dispatch, Id]);
    useEffect(() => {
        if (singleLogo.data.length > 0) {
            const item = singleLogo.data[0];
            setFormData({
                ...formData,
                logoNm: item.logoNm,
                logoImg: item.logoImg
            });
        }
    }, [singleLogo])

    if (!singleLogo) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const handleImageChange = (e) => {
        setFormData({
            ...formData,
            image: e.target.files[0]
        });
    };




    const handleSubmit = (event) => {
        event.preventDefault();

        dispatch(updateLogoEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Logo Updated");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };





    return (
        <>

            <div style={{ margin: '1%' }}>
                <h2>Logo Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={2}>
                                {[
                                    { label: 'Logo Name', name: 'logoNm' },
                                    { label: 'Logo Image', name: 'logoImg', type: 'file' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'file' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="file"
                                                            onChange={handleImageChange}
                                                            inputProps={{ style: styled.inputImg }}
                                                            sx={inputImages}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default LogoEdit;
